import { SoStatusEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";

export class InsuranceDto{
    @ApiProperty()
    insurancefileId: number;
    @ApiProperty()
    originalname:string;
    @ApiProperty()
    filePath: string;
    @ApiProperty()
    fileName: string;
    @ApiProperty()
    destination: string;
    @ApiProperty()
    saleOrderId: number;
    @ApiProperty()
    saleOrderName?: string;
    @ApiProperty()
    isActive?: boolean;
    @ApiProperty()
    createdUser?: string | null;
    @ApiProperty()
    updatedUser?: string | null;
}